import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/main.scss';

// Evitar que la rueda del mouse altere importes o cantidades accidentalmente.
// El desplazamiento de la página sigue funcionando; las flechas del control y
// la escritura manual permanecen disponibles en todos los módulos del ERP.
document.addEventListener('wheel', (event) => {
  const active = document.activeElement;
  if (active instanceof HTMLInputElement && active.type === 'number' &&
      (event.target === active || active.contains(event.target))) {
    active.blur();
  }
}, { capture: true, passive: true });

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
